// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__h2w1B {
  padding-top: 24px;
  display: flex;
  gap: 24px;
  border-top: 1px dashed rgba(255, 255, 255, 0.05);
}
@media (max-width: 768px) {
  .styles_wrapper__h2w1B {
    flex-direction: column;
    gap: 16px;
    padding-top: 0;
    border-top: none;
  }
}

.styles_cardWrapper__HrH4x {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
}
@media (max-width: 1200px) {
  .styles_cardWrapper__HrH4x {
    padding: 16px;
    gap: 8px;
  }
}
@media (max-width: 768px) {
  .styles_cardWrapper__HrH4x {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.styles_cardHeading__TuFSa {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_cardHeading__TuFSa {
    font-size: 12px;
  }
}

.styles_buttonWrapper__Ltnrr {
  height: 64px;
  min-width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/content/cardList/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,aAAA;EACA,SAAA;EACA,gDAAA;AAFF;AC0BE;ED5BF;IAOI,sBAAA;IACA,SAAA;IACA,cAAA;IACA,gBAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,8BENS;EFOT,mBAAA;AADF;ACJE;EDFF;IAUI,aAAA;IACA,QAAA;EAAF;AACF;ACEE;EDdF;IAeI,mBAAA;IACA,8BAAA;IACA,mBAAA;EACF;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BErCS;AFsCX;ACzBE;EDmBF;IAQI,eAAA;EAEF;AACF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  padding-top: 24px;\n  display: flex;\n  gap: 24px;\n  border-top: 1px dashed $white-5;\n\n  @include md {\n    flex-direction: column;\n    gap: 16px;\n    padding-top: 0;\n    border-top: none;\n  }\n}\n\n.cardWrapper {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  background: $black-30;\n  border-radius: 16px;\n\n  @include xl {\n    padding: 16px;\n    gap: 8px;\n  }\n\n  @include md {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.cardHeading {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n\n  @include xl {\n    font-size: 12px;\n  }\n}\n\n.buttonWrapper {\n  height: 64px;\n  min-width: 120px;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__h2w1B`,
	"cardWrapper": `styles_cardWrapper__HrH4x`,
	"cardHeading": `styles_cardHeading__TuFSa`,
	"buttonWrapper": `styles_buttonWrapper__Ltnrr`
};
export default ___CSS_LOADER_EXPORT___;
